import React, { useState, useEffect } from "react";
// components
import { Container, Row, Col } from "react-bootstrap";
import TvIcon from "@material-ui/icons/Tv";
import FormatPaintOutlinedIcon from "@material-ui/icons/FormatPaintOutlined";
import OpacityIcon from "@material-ui/icons/Opacity";
import AddIcon from "@material-ui/icons/Add";
import CustomGreenButton from "../../components/shared/custom-green-button";
import swal from "sweetalert";
// data
import { GENERAL_URL_API } from "../../shared/urls";
import BannersTable from "./banners-table";
import CrearBannerIndividual from "./crear-banner";

const CambiarLosBanners = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCrearBanner, setShowCrearBanner] = useState(false);

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    setLoading(true);
    try {
      const fd = new FormData();
      const res = await fetch(`${GENERAL_URL_API}/arte/verBanners.php`, {
        method: "POST", 
        credentials: 'include',
        body: fd,
      });
      const data = await res.json();
      setBanners(data.data || []);
    } catch (error) {
      console.error('Error fetching banners:', error);
      // Datos de ejemplo para desarrollo
      setBanners([
        {
          id: 1,
          titulo: "Banner Promocional Libros",
          tipo: "Promocional",
          alcance: "Global",
          asignado: "Todos los institutos",
          activo: "1",
        },
        {
          id: 2,
          titulo: "Banner Evento Especial",
          tipo: "Evento",
          alcance: "Específico",
          asignado: "Instituto ABC",
          activo: "1",
        },
        {
          id: 3,
          titulo: "Banner Mantenimiento",
          tipo: "Informativo",
          alcance: "Global",
          asignado: "Todos los institutos",
          activo: "0",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleBannerUpdate = () => {
    fetchBanners();
  };

  const handleCreateBanner = () => {
    setShowCrearBanner(true);
  };

  const handleBannerCreated = () => {
    setShowCrearBanner(false);
    fetchBanners();
  };

  const handleCancelCrearBanner = () => {
    setShowCrearBanner(false);
  };

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <FormatPaintOutlinedIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">
          Gestión de Banners
        </div>
      </div>

      <Container fluid>
        <Row>
          {showCrearBanner ? (
            <CrearBannerIndividual
              onBannerCreated={handleBannerCreated}
              clearEdit={handleCancelCrearBanner}
              onVolver={handleCancelCrearBanner}
            />
          ) : (
            <Col xs={12} className="content-white-box px-4 py-4">
              <div className="d-flex align-items-center">
                <OpacityIcon style={{ fontSize: "22px" }} />
                <div className="admin-main-title-dark-gray ml-2 mt-1">
                  Tabla de Banners
                </div>
              </div>
              <div className="admin-muted-text-small mt-1 mb-3">
                Gestión y administración de banners del sistema
              </div>
              
              <div className="d-flex justify-content-end mb-3">
                <CustomGreenButton
                  size="medium"
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={handleCreateBanner}
                >
                  Crear Banner
                </CustomGreenButton>
              </div>
              
              <BannersTable
                banners={banners}
                loading={loading}
                onBannerUpdate={handleBannerUpdate}
              />
            </Col>
          )}
        </Row>
      </Container>
    </>
  );
};

export default CambiarLosBanners;
